import styled from 'styled-components';

export const UserInvitationStyled = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-bottom: 24px;
`;
